import React from 'react';
import Modal from 'react-modal';

interface AuthWebModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default class AuthWebModal extends React.Component<AuthWebModalProps> {
    // eslint-disable-next-line
    constructor(props: AuthWebModalProps) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <Modal isOpen={this.props.isOpen} onRequestClose={this.props.onClose} className="authweb-modal" ariaHideApp={false}>
                <div className="content">
                    <div className="close-icon" onClick={this.props.onClose}>
                        <img alt="close" src={require('../../assets/media/img/login/close.svg')} />
                    </div>
                    <h2>Geolocalización</h2>

                    <div className="policies">
                        <p>
                            Para tú seguridad y para darle cumplimiento a las disposiciones regulatorias aplicables es necesaria tú autorización para
                            recabar y utilizar tu geolocalización (las coordenadas geográficas de latitud y longitud) del dispositivo en donde
                            realices las operaciones a través de la presente aplicación. Deberás de otorgar el consentimiento para acceder a los datos
                            de geolocalización de tu dispositivo, de lo contrario, estarás imposibilitado de realizar operaciones o transacciones por
                            este medio.
                        </p>

                        <p>
                            Por lo tanto, al continuar e ingresar tú token (la aceptación tendrá la misma validez y producirá los mismos efectos
                            jurídicos, puesto que, sustituyen a tú firma autógrafa para todos los efectos legales) aceptas que Banco Base acceda a los
                            datos de geolocalización de tu dispositivo y lo liberas de cualquier responsabilidad en caso de no otorgar el presente
                            consentimiento, obligándote a sacarlo en paz y a salvo en caso de que se presente cualquier controversia por dicho motivo.
                        </p>

                        <p>Autorizo a Banco Base para recabar y utilizar la geolocalización de mi dispositivo.</p>
                    </div>

                    <div className="container-button">
                        <button id="FXd__button-primary" className="btn button-primary" disabled={false} onClick={this.props.onClose}>
                            Autorizar acceso a mi ubicación
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}
